<template>
  <el-form
    ref="hangarUsagesDataForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="hangar-usages-data-form"
  >
    <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :actualprop=true />
    <ActionType v-model="hangarUsageActionType" label="入出庫区分" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" mode="hangarUsage" />
    <CustomerCode v-model="operatorCode" label="運航者" prop="operator_code" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :autocomplete-list="autocompleteCustomerCodeSet" />
    <RegistrationSymbol v-model="registrationSymbol" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" :autocomplete-list="autocompleteRegistrationSymbolSet" />
    <template v-if='formMode === "search"'>
      <DateTimeRange :dateTimeFrom.sync="hangarUsageActionTimeFrom" :dateTimeTo.sync="hangarUsageActionTimeTo" label="入出庫日時"
        :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
    </template>
    <template v-else>
      <DateTime v-model="hangarUsageActionTime" label="入出庫日時" prop="hangar_usage_action_time"
        :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
    </template>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'

export default {
  components: {
    BillingYm,
    ActionType,
    CustomerCode,
    RegistrationSymbol,
    DateTime,
    DateTimeRange
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: String,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    hangarUsageActionType: {
      get () {
        return this.model.action_type
      },
      set (hangarUsageActionType) {
        const form = { ...this.model }
        form.action_type = hangarUsageActionType
        this.$emit('input', form)
      }
    },
    operatorCode: {
      get () {
        return this.model.operator_code
      },
      set (operatorCode) {
        const form = { ...this.model }
        form.operator_code = operatorCode
        this.$emit('input', form)
      }
    },
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    hangarUsageActionTime: {
      get () {
        return this.model.hangar_usage_action_time
      },
      set (hangarUsageActionTime) {
        const form = { ...this.model }
        form.hangar_usage_action_time = hangarUsageActionTime
        this.$emit('input', form)
      }
    },
    hangarUsageActionTimeFrom: {
      get () {
        return this.model.hangar_usage_action_time_from
      },
      set (hangarUsageActionTimeFrom) {
        const form = { ...this.model }
        form.hangar_usage_action_time_from = hangarUsageActionTimeFrom
        this.$emit('input', form)
      }
    },
    hangarUsageActionTimeTo: {
      get () {
        return this.model.hangar_usage_action_time_to
      },
      set (hangarUsageActionTimeTo) {
        const form = { ...this.model }
        form.hangar_usage_action_time_to = hangarUsageActionTimeTo
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.hangarUsagesDataForm.resetFields()
      if (this.searchMode) {
        this.model.hangar_usage_action_time_from = null
        this.model.hangar_usage_action_time_to = null
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.hangarUsagesDataForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.hangar-usages-data-form {
  .el-form-item.date-time-range{
    .el-input__inner{
      width: 30em;
    }
  }
  .el-form-item{
    .el-input__inner{
      width: 18em;
    }
  }
}
</style>
